export default __webpack_public_path__ + "static/media/873.18084f8d.png";